<template lang="pug">
  .share-panel-with-project-list
    GuiaParticipacion(:showDialog.sync="guiaParticipacionOpen" @onCloseEvent="closeGuiaParticipacion()")

    SharePanel(
      :header="header"
      :footer="footer"
      :projectInfo="selectedProject"
      :data="getDataToShare()"
      :link="getLinkToShare()"
      @sendMailDialogOpenEvent="openDialogOrProjectList"
      @abrirGuiaParticipacionEvent="openGuiaParticipacion()"
      @sendWhatsappMessageDialogEvent="openDialogOrProjectList"
      )
    SendMailDialog(
      :open.sync="sendMailDialogOpen"
      :title="title"
      :description="description"
      :projectInfo="selectedProject"
      :initialMessageType="messageType"
      @on-help-click="openGuiaParticipacion()"
    )

    v-dialog(v-model="projectListDialogOpen" scrollable)
      v-card
        v-card-title
          AyudaButton(@on-click="openGuiaParticipacion")
          v-layout.wrap
            v-flex.xs12
              .participe
                img(src="@/assets/img/icons/participe.svg" class="participe-icon")
                span Participa
                .asu-subtitle Consulta, Sugerencia, Reclamo
            v-flex.xs12.text-xs-center
              span.asu-title.d-inline-block Seleccione un proyecto
        v-card-text(style="padding: 0;")
          ProjectListPanel(@selectProject="selectProject" :noClose="true" :inSharePanel="true")
        v-card-actions
          v-btn(flat @click="closeDialogOrProjectList()") Cancelar

    WhatsappDialog(:openDialog="showWhatsappDialog" @closeWhatsappDialog="showWhatsappDialog=false")

</template>

<script>
import { mapActions } from 'vuex'

const url = process.env.VUE_APP_BASE_URL

export default {
  components: {
    SharePanel: _ => import('./SharePanel'),
    SendMailDialog: _ => import('./SendMailDialog'),
    ProjectListPanel: _ => import('./ProjectListPanel'),
    GuiaParticipacion: _ => import('./GuiaParticipacion'),
    AyudaButton: _ => import('./AyudaButton'),
    WhatsappDialog: _ => import('@/components/WhatsappDialog')
  },
  mounted () {
    this.selectedProject = this.projectInfo || {}
    if (this.promptOpenOnPageLoad) {
      if (this.promptOpenOnPageLoad === 'enviarMensaje') { this.openDialogOrProjectList() } else if (this.promptOpenOnPageLoad === 'ayuda') { this.guiaParticipacionOpen = true }
    }
    this.messageType = this.initialMessageType
  },
  methods: {
    ...mapActions([
      'toggle',
      'activateControl'
    ]),

    closeDialogOrProjectList () {
      this.sendMailDialogOpen = false
      this.projectListDialogOpen = false
    },

    openDialogOrProjectList: function (argMessageType) {
      this.messageType = argMessageType
      if (this.isParticipaPage) {
        this.activateControl('projectList')
        this.projectListDialogOpen = true
        this.sendMailDialogOpen = false
      } else {
        if (this.messageType === 'Whatsapp' && this.selectedProject) {
          if (this.selectedProject.whatsapp) {
            open(`http://wa.me/${this.selectedProject.whatsapp}`, '_blank')
          } else {
            this.openWhatsappDialog()
          }
        } else {
          this.openDialog()
        }
      }
    },

    selectProject (event) {
      this.selectedProject = event
      if (this.messageType === 'Whatsapp') {
        if (this.selectedProject.whatsapp) {
          open(`http://wa.me/${this.selectedProject.whatsapp}`, '_blank')
        } else {
          this.openWhatsappDialog()
        }
        this.projectListDialogOpen = false
      } else {
        this.openDialog()
      }
    },

    openDialog () {
      this.projectListDialogOpen = false
      this.sendMailDialogOpen = true
    },

    openGuiaParticipacion () {
      if (this.projectListDialogOpen || this.sendMailDialogOpen) {
        if (this.projectListDialogOpen) {
          this.previousDialog = 'projectList'
        } else if (this.sendMailDialogOpen) {
          this.previousDialog = 'sendMail'
        }
        this.projectListDialogOpen = false
        this.sendMailDialogOpen = false
      }
      this.guiaParticipacionOpen = true
    },

    openWhatsappDialog () {
      this.showWhatsappDialog = true
    },

    closeGuiaParticipacion () {
      this.guiaParticipacionOpen = false
      if (this.$route.path === '/participacion-ayuda') {
        this.$router.replace({ name: 'home' })
      }
      if (this.previousDialog === 'projectList') {
        this.projectListDialogOpen = true
        this.previousDialog = ''
      } else if (this.previousDialog === 'sendMail') {
        this.sendMailDialogOpen = true
        this.previousDialog = ''
      }
    },

    getDataToShare () {
      if (this.selectedProject.code) return `${this.selectedProject.name} - ${url}map?code=${this.selectedProject.code}`
      return url
    },

    getLinkToShare () {
      if (this.selectedProject.code) return `${url}map?code=${this.selectedProject.code}`
      return url
    }
  },
  props: {
    title: {
      default: 'Participa',
      type: String
    },
    description: {
      default: 'Envía tu comentario para Asu participa',
      type: String
    },
    footer: {
      type: Boolean,
      default: false
    },
    projectInfo: {
      type: Object,
      default: () => ({ name: '', code: '' })
    },
    isParticipaPage: {
      type: Boolean,
      default: false
    },
    header: {
      type: Boolean,
      default: false
    },
    promptOpenOnPageLoad: null,
    initialMessageType: null
  },
  watch: {
    projectInfo () {
      this.selectedProject = this.projectInfo || {}
    }
  },
  data () {
    return {
      selectedProject: {},
      sendMailDialogOpen: false,
      projectListDialogOpen: false,
      guiaParticipacionOpen: false,
      previousDialog: '',
      messageType: '',
      showWhatsappDialog: false
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

.asu-title
  margin: $f10px 0 0

.v-card-title
  margin-bottom: 0

.participe
  color: $color_0
  user-select: none

.asu-subtitle
  font-size: $f13px

.v-dialog__content >>> .v-dialog.v-dialog--active
  min-width: $f280px
  max-width: 80%
  max-height: 80%
  .isMobile &
    width: 100vmax
    min-width: 100%
    max-width: 100%
    max-height: 100%
    margin-left: 0
    margin-right: 0
    .v-card
      padding-top: $f25px

</style>
